import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SafeIcon from '../common/SafeIcon';
import * as LuIcons from 'react-icons/lu';

const { LuStar, LuMapPin, LuClock, LuExternalLink, LuCircleCheck } = LuIcons;

const GoogleBusinessSection = () => {
  const { t } = useTranslation();

  const reviews = [
    {
      author: "Ntegianira Seberino",
      rating: 5,
      text: "De reparerade min båt snabbt medan jag satt och drack en kaffe där bra pris.",
      date: "a few weeks ago"
    },
    {
      author: "Elvira Gunnarsson",
      rating: 5,
      text: "Super duktig kille som är mån om att bilen ska hålla kvalitet. Fräsch verkstad och han jobbar snabbt och är jättesnäll. Rekommenderar alla att besöka verkstad 360 😊 …",
      date: "a month ago"
    },
    {
      author: "Colin Scott Wheatley",
      rating: 5,
      text: "Väl utbildade och erfaren mekaniker. Duktig på diagnos, jobba effektiv och snabt",
      date: "a week ago"
    }
  ];

  return (
    <section id="google-business" className="section-container bg-opacity-30">
      <div className="section-header text-center mb-16">
        <div className="google-badge-top">
          <div className="google-logo">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-3.3 3.28-8.19 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
            </svg>
          </div>
          <span>{t('googleBusiness.ratingLabel')}</span>
          <div className="stars">
            {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={LuStar} className="text-yellow-400 fill-yellow-400" />)}
          </div>
          <span className="rating-val">5.0</span>
        </div>
        <h2 className="section-title mt-6">{t('googleBusiness.title')}</h2>
        <p className="section-subtitle">{t('googleBusiness.subtitle')}</p>
      </div>

      <div className="business-grid">
        {/* --- REVIEWS COLUMN --- */}
        <div className="reviews-column">
          {reviews.map((rev, i) => (
            <motion.div 
              key={i} 
              className="review-card glass-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="rev-header">
                <div className="rev-avatar">{rev.author[0]}</div>
                <div className="rev-meta">
                  <strong>{rev.author}</strong>
                  <span>{rev.date}</span>
                </div>
                <div className="rev-verified">
                  <SafeIcon icon={LuCircleCheck} />
                </div>
              </div>
              <div className="rev-stars">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={LuStar} size={14} className="text-yellow-400 fill-yellow-400" />)}
              </div>
              <p className="rev-text">"{rev.text}"</p>
            </motion.div>
          ))}
          <a 
            href="https://www.google.com/maps/place/Verkstad360/@58.9378439,11.2000135,17z/data=!4m8!3m7!1s0x46443fec6da896af:0xffec8359a9c7b2c5!8m2!3d58.9378439!4d11.2000135!9m1!1b1!16s%2Fg%2F11z4v0tp8r?hl=en&entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D" 
            target="_blank" 
            className="view-more-reviews"
          >
            {t('googleBusiness.viewAll')} <SafeIcon icon={LuExternalLink} />
          </a>
        </div>

        {/* --- MAP & INFO COLUMN --- */}
        <div className="info-column" style={{ marginBottom: '0' }}>

          <div className="business-details glass-card mt-6" style={{ marginBottom: '0' }}>
            <div className="detail-item">
              <div className="detail-icon"><SafeIcon icon={LuMapPin} /></div>
              <div>
                <p>Prästängsvägen 11</p>
                <strong>45292 Strömstad, Sweden</strong>
              </div>
            </div>
            <div className="detail-item">
              <div className="detail-icon"><SafeIcon icon={LuClock} /></div>
              <div>
                <p>{t('googleBusiness.hours')}</p>
                <strong>{t('googleBusiness.monFri')}: 08:00 - 16:00</strong>
                <p className="text-xs opacity-50">{t('googleBusiness.satSun')}: {t('googleBusiness.closed')}</p>
              </div>
            </div>
          </div>

          <div className="map-wrapper glass-card">
            <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2058.6046313161905!2d11.2003183!3d58.938054400000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46443fec6da896af%3A0xffec8359a9c7b2c5!2sVerkstad360!5e0!3m2!1sen!2sat!4v1777903911403!5m2!1sen!2sat"
              width="100%" 
              height="350" 
              style={{ border: 0, borderRadius: '16px' }} 
              allowFullScreen="" 
              loading="lazy" 
            />
          </div>

        </div>
      </div>

      <style jsx>{`
        .google-badge-top {
          display: inline-flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.75rem;
          background: rgba(221,219,230,0.05);
          padding: 0.5rem 1.25rem;
          border-radius: 30px;
          border: 1px solid rgba(221,219,230,0.1);
          font-weight: 600;
          font-size: 0.9rem;
          color: #DDDBE6;
          max-width: 100%;
        }
        .stars { display: flex; gap: 2px; }
        .rating-val { color: white; background: #34A853; padding: 2px 6px; border-radius: 4px; font-size: 0.8rem; }
        
        .business-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          max-width: 1300px;
          margin: 0 auto;
        }

        .review-card {
          margin-bottom: 1.5rem;
          padding: 1.5rem 2rem;
        }
        .rev-header { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; }
        .rev-avatar { width: 40px; height: 40px; background: var(--primary-gradient); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; color: white; }
        .rev-meta { flex: 1; display: flex; flex-direction: column; }
        .rev-meta strong { font-size: 1rem; color: white; }
        .rev-meta span { font-size: 0.8rem; color: #848489; }
        .rev-verified { color: #34A853; font-size: 1.1rem; }
        .rev-stars { display: flex; gap: 2px; margin-bottom: 0.75rem; }
        .rev-text { font-size: 0.95rem; color: #DDDBE6; line-height: 1.6; font-style: italic; }

        .view-more-reviews {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          color: #8377BE;
          font-weight: 600;
          text-decoration: none;
          padding: 1rem;
          transition: 0.3s;
        }
        .view-more-reviews:hover { color: white; transform: translateX(5px); }

        .map-wrapper { padding: 0.5rem; margin-top: 3rem; overflow: hidden; }
        
        .detail-item { display: flex; gap: 1.5rem; margin-bottom: 1.5rem; }
        .detail-item:last-child { margin-bottom: 0; }
        .detail-icon { width: 44px; height: 44px; background: rgba(131,119,190,0.1); border-radius: 12px; display: flex; align-items: center; justify-content: center; color: #8377BE; font-size: 1.2rem; }
        .detail-item p { font-size: 0.85rem; color: #848489; }
        .detail-item strong { color: white; font-size: 1rem; }

        @media (max-width: 1024px) {
          .business-grid { grid-template-columns: 1fr; }
        }

        @media (max-width: 768px) {
          .section-title { font-size: 2.2rem; }
          .section-subtitle { font-size: 1rem; }
          .review-card { padding: 1.25rem 1.5rem; }
          .business-grid { gap: 2rem; }
          .map-wrapper { margin-top: 1.5rem; }
        }

        @media (max-width: 480px) {
          .section-title { font-size: 1.9rem; }
          .rev-text { font-size: 0.88rem; }
          .detail-item { gap: 1rem; }
          .google-badge-top { font-size: 0.8rem; padding: 0.4rem 1rem; }
          .map-wrapper iframe { height: 260px; }
        }
      `}</style>
    </section>
  );
};

export default GoogleBusinessSection;